import * as React from 'react';

import { mapToFrontendType } from 'store/programItems';

import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

import { createStaticIcon } from 'components/atoms/Icon';
import Link from 'components/atoms/Link';
import Loader from 'components/atoms/Loader';
import FavoriteTeaser from 'components/molecules/Favorite/Teaser';
import FavoriteTeaserCell from 'components/organisms/Profile/FavoriteTeaserCell';
import { FavoriteType } from 'types/Favorites';

import routesConfig from 'defs/routes';
import i18n from 'helper/i18n';

export type ProfileFavoritePropsType = {
	isSequenceLoading: boolean;
	favorites: Array<FavoriteType>;
	favoritesLength: number;
	totalFavoritesLength: number;
	doLoadFavorites: () => void;
};

export class ProfileFavorite extends React.Component<ProfileFavoritePropsType> {
	public static displayName = 'ProfileFavorite';

	public componentDidMount() {
		this.props.doLoadFavorites();
	}

	get favoriteTitle(): string {
		return i18n('react.impulsCoach.views.Profile.favorite.title', {
			counter: this.props.totalFavoritesLength,
			icon: `<span class="o-profile__title-icon">${createStaticIcon('heart-filled')}</span>`,
			__disableHtmlEncoding: true,
		});
	}

	get favoriteDescription(): string {
		return i18n('react.impulsCoach.views.Profile.favorite.description');
	}

	get emptyFavoriteDescription(): string {
		return i18n('react.impulsCoach.views.Profile.favorite.emptyDescription', {
			icon: `<span class="o-profile__text-icon">${createStaticIcon('heart')}</span>`,
			__disableHtmlEncoding: true,
		});
	}

	public render() {
		const { isSequenceLoading, favorites, totalFavoritesLength } = this.props;

		if (isSequenceLoading) {
			return (
				<div className="o-profile__content">
					<div className="row">
						<Loader hasContainer={false} />
					</div>
				</div>
			);
		}

		if (!(favorites instanceof Array)) {
			return null;
		}

		return (
			<div className="o-profile__content">
				<div className="row">
					<div className="col-xs-12 col-md-7">
						<h4
							className="o-profile__title"
							dangerouslySetInnerHTML={{
								__html: this.favoriteTitle,
							}}
						/>
						{totalFavoritesLength > 0 && <p className="o-profile__text">{this.favoriteDescription}</p>}
						{totalFavoritesLength === 0 && (
							<div className="o-profile__intro">
								<p
									className="o-profile__text"
									dangerouslySetInnerHTML={{
										__html: this.emptyFavoriteDescription,
									}}
								/>
							</div>
						)}
					</div>
				</div>
				<div className="row">
					{favorites.slice(0, 3).map((favorite: FavoriteType, index: number) => {
						return (
							<FavoriteTeaserCell
								key={`$.favorite-${index}-${favorite.contentType}-${favorite.externalId}`}
							>
								<FavoriteTeaser
									{...(favorite as any)}
									image={favorite.previewImage || favorite.fallbackImage || {}}
									frontendContentType={mapToFrontendType(favorite.contentType)}
								/>
							</FavoriteTeaserCell>
						);
					})}
				</div>
				{totalFavoritesLength > 0 && (
					<div className="o-profile__button">
						<Link
							href={routesConfig.favorites.indexRoute.href}
							modifier="button-green"
							title={i18n('react.impulsCoach.views.Profile.favorite.btnText')}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default withSequenceState(ProfileFavorite, [Sequences.FAVORITES_IS_LOADING]);
